import {
  InvoiceScheme,
  InvoiceType,
  VatRateType,
} from '../../../Invoices/Types/invoicesTypes';
import {
  getAllowedVatTypesForInvoice,
  VAT_TYPE_DISPLAY_LABELS,
} from '../../../Invoices/utils/vatMappings';
import { normalizeInvoiceScheme } from '../../../Invoices/utils/invoiceEnumNormalization';

export { InvoiceScheme, VatRateType, normalizeInvoiceScheme };

export const getAllowedVatTypesForBatchInvoice = (
  scheme: string | null | undefined
): VatRateType[] =>
  getAllowedVatTypesForInvoice(normalizeInvoiceScheme(scheme ?? ''), InvoiceType.Standard);

export const getBatchInvoiceVatTypeLabel = (vatType: VatRateType): string =>
  VAT_TYPE_DISPLAY_LABELS[vatType];
